import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content__description__directory-type" }
const _hoisted_3 = { class: "content__description__name" }
const _hoisted_4 = { class: "footer-buttons" }

import ModalBase from './ModalBase.vue'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import { computed, onMounted, onUnmounted, ref, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { DirectoryItem } from './types'

type Props = {
  disableSubmit?: boolean
  open?: boolean
  icon?: string
  directoryItem: DirectoryItem
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FileConflictModal',
  props: {
    disableSubmit: { type: Boolean, default: false },
    open: { type: Boolean, default: false },
    icon: { default: undefined },
    directoryItem: {}
  },
  emits: ["close", "replaceItem", "saveCopy"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { disableSubmit, directoryItem } = toRefs(props)
const emit = __emit
const { t } = useI18n()
const title = computed(() => {
  return props.directoryItem.type === 'file'
    ? t('general__data__file-already-exists')
    : t('general__text__directory-already-exists')
})
const fileTypeLocale = computed(() => {
  return props.directoryItem?.type === 'file'
    ? t('general__data__file').toLowerCase()
    : t('general__text__directory').toLowerCase()
})

const isOpen = ref(props.open)
watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue
  },
  { immediate: true }
)
const closeModal = () => {
  emit('close')
  isOpen.value = false
}
const submit = () => {
  emit('saveCopy')
  isOpen.value = false
}
const replaceItem = () => {
  // Logic to replace the existing item
  emit('replaceItem')
  isOpen.value = false
}
onMounted(() => {
  isOpen.value = props.open
})
onUnmounted(() => {
  isOpen.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(ModalBase, {
    title: title.value,
    open: isOpen.value,
    icon: _ctx.icon,
    hideDivider: true,
    hideControls: true,
    onClose: closeModal
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_i18n_t, {
          keypath: "general__text__files-conflict-info",
          tag: "p",
          class: "content__description"
        }, {
          directoryType: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(fileTypeLocale.value), 1)
          ]),
          name: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(directoryItem).name), 1)
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ButtonOutline, {
          buttonText: _unref(t)('general__text__cancel'),
          onOnClicked: closeModal
        }, null, 8, ["buttonText"]),
        _createVNode(ButtonOutline, {
          buttonText: _unref(t)('general__text__replace'),
          onOnClicked: replaceItem
        }, null, 8, ["buttonText"]),
        _createVNode(ButtonPrimary, {
          buttonText: _unref(t)('general__data__save-copy'),
          disabled: _unref(disableSubmit),
          onOnClicked: submit
        }, null, 8, ["buttonText", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["title", "open", "icon"]))
}
}

})